import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { AxiosError, AxiosResponse } from 'axios';

import { vehicleBatchModelInitial } from '../../../../Models/VehicleBatchModel';
import { VehicleModel, vehicleModelInitial } from '../../../../Models/VehicleModel';
import ClassificationVehicleService from '../../../../Services/ClassificationVehicleService';
import VehicleService from '../../../../Services/VehicleService';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import { HomeContext } from '../../../Home/HomeContext';
import { RevisionContext } from '../RevisionContext';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function VehicleBatchCorretion() {

    const revisionContext = React.useContext(RevisionContext);
    const homeContext = React.useContext(HomeContext);
    const batchCorrectionContext = React.useContext(BatchCorrectionContext);

    const [vehicleSelected, setVehicleSelected] = React.useState<VehicleModel | null>(null);
    const [vehicleList, setVehicleList] = React.useState<VehicleModel[]>([]);

    const [vehicleNotDefinedError, setVehicleNotDefinedError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.vehicleBatchOpenDialog) {
            homeContext.setOpenLoadingDialog(true);
            VehicleService.getVehicleByQuery(null, revisionContext.mediaId)
                .then((res: AxiosResponse) => { setVehicleList(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); })
                .finally(() => { homeContext.setOpenLoadingDialog(false); });

        }
    }, [revisionContext.vehicleBatchOpenDialog]);

    const hasError = () => {

        const errorVehicle: boolean = (vehicleList && vehicleList.length > 0 && !vehicleSelected);

        setVehicleNotDefinedError(errorVehicle);

        return (errorVehicle);
    };

    const updateVehicle = () => {
        if (!hasError()) {
            homeContext.setOpenLoadingDialog(true);

            const vehicleData = { ...vehicleBatchModelInitial };
            vehicleData.vehicle = vehicleSelected ? vehicleSelected : vehicleModelInitial;
            vehicleData.classificationsId = revisionContext.ids;

            ClassificationVehicleService.updateVehicleBatch(vehicleData)
                .then(() => {
                    clearModalVehicle();
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} classificações selecionadas com sucesso!`);
                    batchCorrectionContext.setCallSearch(true);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError(' Ops... Ocorreu um erro e não foi possível salvar a alteração de veículo. '
                        + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
                    homeContext.setOpenLoadingDialog(false);
                });
        }
    };

    const clearModalVehicle = () => {
        revisionContext.setVehicleBatchOpenDialog(false);
        setVehicleList([]);
        setVehicleSelected(null);
        setVehicleNotDefinedError(false);
    };

    const getVehicle = () => {
        return (
            <Grid item xs={12} sm={12}>
                <Autocomplete
                    id="vehicle"
                    value={vehicleSelected}
                    onChange={(event, value: VehicleModel | null) => setVehicleSelected(value)}
                    options={vehicleList}
                    getOptionLabel={(option: VehicleModel) => option.nomenclature ? option.nomenclature : option.name}
                    fullWidth
                    noOptionsText="Sem resultados"
                    loadingText="Carregando..."
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Veículo"
                            variant="outlined"
                            error={vehicleNotDefinedError && !vehicleSelected}
                            helperText={vehicleNotDefinedError && !vehicleSelected ? 'Campo obrigatório' : ''} />
                    } />
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Alteração de veículo'}
            description={'Você só poderá alterar para um veículo com mesmo tipo de mídia das notícias selecionadas.'}
            handleFirstButton={() => clearModalVehicle()}
            handleSecondButton={() => updateVehicle()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.vehicleBatchOpenDialog}
            children={getVehicle()}
            cssProperties={{
                minWidth: '600px',
                maxWidth: '600px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}